//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isEqual } from '@/utils/lodash'
import {
  Grid,
  GridItem,
  ImagePreview,
  Uploader,
} from 'vant'
import excelIcon from '../../assets/img/excel_icon.png'
import wordIcon from '../../assets/img/word_icon.png'
import pdfIcon from '../../assets/img/pdf_icon.png'
import fileIcon from '../../assets/img/file_icon.png'
import CInput from '../CInput'
import { toast } from '../../utils/toast'
import { danger } from '@/utils/notify'

export default {
  name: 'CFileUpload',

  components: {
    Grid,
    GridItem,
    Uploader,
    CInput,
  },

  props: {
    mode: {
      type: String,
      default: '',
    },

    required: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: '附件:',
    },

    labelRender: { type: Function },

    labelWidth: {
      type: [
        String,
        Number,
      ],
      default: '5.62500rem',
    },

    multiple: {
      type: Boolean,
      default: true,
    },

    params: {
      type: Object,
      default: () => ({}),
    },

    value: {
      type: [
        Array,
        String,
      ],
      default: () => ([]),
    },

    maxSize: {
      type: [
        String,
        Number,
      ],
    },

    extensions: {
      type: [Array],
      default: () => ([]),
    },

    fileType: { type: Array },

    needOnlyAddress: {
      type: Boolean,
      default: false,
    },

    accept: {
      type: String,
      default: 'image/*',
    },

    fileCount: { type: Number },

    apiMethod: { type: Function },

  },

  data () {
    return {
      innnerList: [],
      uploadList: [],
      files: {
        name: '',
        type: '',
      },
      picValue: null,
      ossFileUrl: '',
    }
  },

  computed: {
    imgList () {
      if (this.value) {
        if (this.value instanceof Array) {
          return this.value?.filter((el) => {
            return this.isImage(el.url)
          })
        }

        if (this.needOnlyAddress && typeof this.value === 'string' && this.isImage(this.value)) {
          return [{ url: this.value }]
        }
      } else {
        return []
      }
    },

    otherList () {
      if (this.value) {
        if (this.value instanceof Array) {
          return this.value?.filter((el) => {
            return !this.isImage(el.url)
          })
        }

        if (this.needOnlyAddress && typeof this.value === 'string' && !this.isImage(this.value)) {
          return [{ url: this.value }]
        }
      } else {
        return []
      }
    },

  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (this.needOnlyAddress && typeof val === 'string') {
          this.uploadList = [{ url: val }]
        } else {
          this.uploadList = val
        }

        if (val?.length && !isEqual(val, oldVal)) {
          this.innnerList = this.uploadList
        }
      },
    },

  },

  methods: {
    getFormData (baseFile, url) {
      let file = baseFile.file

      if (url) {
        file = this.dataURLtoFile(url)
      }

      const formData = new FormData()

      formData.append('file', file)
      for (const key in this.params) {
        if (this.params.hasOwnProperty(key)) {
          const value = this.params[key]

          formData.append(key, value)
        }
      }

      return formData
    },

    onRead (file) {
      if (file instanceof Array) {
        file.forEach((el) => {
          this.handlerAfterUpload(el)
        })
      } else {
        this.handlerAfterUpload(file)
      }

      this.$emit('upload-status', 'uploading')
    },

    handlerAfterUpload (file) {
      file.status = 'uploading'
      file.message = '上传中...'
      this.files.name = file.file.name // 获取文件名
      this.files.type = file.file.type // 获取类型
      this.files.status = file.status // 获取类型
      this.picValue = file.file // 文件流

      if (/^image/.test(file.type)) {
        this.imgPreview(this.picValue, file)
      } else {
        this.postImg(file)
      }
    },

    async postImg (localFile, url) {
      this.$emit('upload-status', 'uploading')
      const formData = await this.getFormData(localFile, url)

      const data = await this.apiMethod(formData)

      if (+data.code === 0) {
        localFile.status = 'done'
        this.files.status = 'done'
        const fileInfo = data.data || {}
        const uploadInfo = {
          status: 'done',
          url: fileInfo.filePath,
          fileName: fileInfo.fileName,
          name: fileInfo.fileName,
        }

        // const tempImgInfo = {
        //   title: uploadInfo.fileName,
        //   url: uploadInfo.url,
        //   fileName: `${uploadInfo.filePath}.${uploadInfo.ext}`,
        //   filePath: uploadInfo.filePath,
        //   ext: uploadInfo.ext,
        // }
        if (!this.multiple) {
          this.uploadList = [uploadInfo]
        } else {
          this.uploadList.push(uploadInfo)
        }

        this.$emit('upload-status', 'done')
        this.$emit('on-upload-success', this.uploadList)
      } else {
        localFile.status = 'failed'
        this.files.status = 'failed'

        this.$emit('upload-status', 'failed')

        danger(data.message)
      }

      this.$emit('input', this.uploadList)
    },

    // 处理图片
    imgPreview (file, localFile) {
      const self = this
      let Orientation

      // 去获取拍照时的信息，解决拍出来的照片旋转问题
      // Exif.getData(file, function () {
      //   Orientation = Exif.getTag(this, 'Orientation')
      // })

      // 看支持不支持FileReader
      if (!file || !window.FileReader) {
        return
      }

      // 创建一个reader
      const reader = new FileReader()

      // 将图片2将转成 base64 格式
      reader.readAsDataURL(file)

      // 读取成功后的回调
      reader.onloadend = function () {
        const result = this.result
        const img = new Image()
        img.src = result

        // 判断图片是否大于500K,是就直接上传，反之压缩图片
        if (this.result.length <= 500 * 1024) {
          self.postImg(localFile, this.result)
        } else {
          img.onload = function () {
            const data = self.compress(img, Orientation)

            self.postImg(localFile, data)
          }
        }
      }
    },

    // 压缩图片
    compress (img, Orientation) {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      // 瓦片canvas
      const tCanvas = document.createElement('canvas')
      const tctx = tCanvas.getContext('2d')

      // let initSize = img.src.length;
      let width = img.width
      let height = img.height

      // 如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio

      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio)
        width /= ratio
        height /= ratio
      } else {
        ratio = 1
      }

      canvas.width = width
      canvas.height = height

      //    铺底色
      ctx.fillStyle = '#fff'

      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // 如果图片像素大于100万则使用瓦片绘制
      let count

      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1) // 计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        const nw = ~~(width / count)
        const nh = ~~(height / count)
        tCanvas.width = nw
        tCanvas.height = nh

        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh)
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh)
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height)
      }

      // 修复ios上传图片的时候 被旋转的问题
      if (Orientation !== '' && Orientation !== 1) {
        switch (Orientation) {
          case 6: // 需要顺时针（向左）90度旋转
            this.rotateImg(img, 'left', canvas)
            break
          case 8: // 需要逆时针（向右）90度旋转
            this.rotateImg(img, 'right', canvas)
            break
          case 3: // 需要180度旋转
            this.rotateImg(img, 'right', canvas) // 转两次
            this.rotateImg(img, 'right', canvas)
            break
        }
      }

      // 进行最小压缩
      const ndata = canvas.toDataURL('image/jpeg', 0.1)
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0

      return ndata
    },

    // 将base64转换为文件
    dataURLtoFile (dataurl) {
      const arr = dataurl.split(',')
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new File([u8arr], this.files.name, { type: this.files.type })
    },

    async deleteImg (file) {
      const index = this.uploadList.findIndex((el) => el.url === file.url)

      this.uploadList.splice(index, 1)
      this.$emit('input', this.uploadList)
    },

    checkFile (file, allFile = []) {
      if (this.fileType && this.fileType.indexOf(file.type) <= 0) {
        toast(`文件格式错误`)

        return false
      }

      if (this.maxSize) {
        let flag = true
        const sizeStr = `${this.maxSize}`

        sizeStr.replace(/(\d+)MB/, (m, $1) => {
          if (file.size > ($1 * 1024 * 1024)) {
            flag = false
          }
        })

        sizeStr.replace(/(\d+)KB/, (m, $1) => {
          if (file.size > ($1 * 1024)) {
            flag = false
          }
        })

        if (!flag) {
          toast(`文件大小不得超过${sizeStr}`)

          return flag
        }
      }

      if ((this.uploadList?.length + allFile?.length) >= this.fileCount) {
        toast(`文件不得超过${this.fileCount}个`)

        return false
      }

      if (file?.name?.length > 60) {
        toast('上传文件名称不超过60个字符')

        return false
      }

      return true
    },

    beforeRead (file) {
      let flag = false

      if (file instanceof Array) {
        for (let i = 0; i < file.length; i++) {
          flag = this.checkFile(file[i], file)

          if (!flag) {
            break
          }
        }
      } else {
        flag = this.checkFile(file)
      }

      return flag
    },

    getFileType (url) {
      if (url) {
        url = url.replace(/\?.*/, '')
      }

      const type = url.substring(url.lastIndexOf('.') + 1)

      return type
    },

    getFileIcon (url) {
      const type = this.getFileType(url)
      let icon

      switch (type) {
        case 'xlsx': icon = excelIcon; break
        case 'docx': icon = wordIcon; break
        case 'pdf': icon = pdfIcon; break
        default: icon = fileIcon
      }

      return icon
    },

    isImage (url) {
      const type = this.getFileType(url)

      return type === 'png' || type === 'jpg' || type === 'jpeg'
    },

    preView (img) {
      ImagePreview(this.imgList.map((el) => el.url))
    },
  },
}
